module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kNajT"))).then(() => parcelRequire('1iHdE'));